<form #form="ngForm"
      method="post"
      id="form">
    @if (basket.qty) {
    <div class="wrap p-b-12 p-b-3-s p-b-3-m p-t-4"
         bottomPanelArea="basketButton"
         cy-basketView
         *ifSize="'SM'">
        <go-back></go-back>
        <div class="m-t-9">
            <h1 class="h3 inline-block va-m"
                translate>Basket</h1>
            <div class="p2 col-12 inline-block m-l-3 va-m">
                {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
            </div>
        </div>
        <span class="p2 col-11 m-t-1 m-b-1 block"
              *iCms="'basketStockMessaging' of content; skipEmpty: true"
              text></span>
        @if (content.showEuRegulationsMessage) {
        <div class="p-t-3 p-b-3 m-b-4 m-t-4 center"
             [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}">
            <span class="p2"
                  *iCms="'euRegulationsMessage' of content; content: 'html'"></span>
        </div>
        }
        @if (basket.items.length > 1) {
        <div class="p-t-3 p-b-3 m-b-4 m-t-4 center"
             [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}">
            <span class="p2"
                  *iCms="'basketMessage' of content"
                  text></span>
        </div>
        }
        <basket-free-shipping clas="m-t-6 block"></basket-free-shipping>
        <div class="m-t-5"></div>
        @for (item of basket.items | orderBy : ['data.added_at'] : ['desc']; track itemTrackFn($index, item); let last =
        $last) {
        <div [ngClass]="{'p-b': item.product.data.isProductProtectionPlan}"
             [class.b-b]="!last">
            <basket-view-item class="block m-t p-b"
                              [item]="item"
                              cy-basketProd></basket-view-item>
            @if (item?.product?.data?.isProductProtectionPlan) {
            <input-wrap class="flex-grow"
                        [required]="true"
                        [messages]="{required: 'You must read and accept the terms and conditions to continue'}">
                <checkbox #protectionPlanCheckbox
                          class="w-12 p-a-3 m-t--4 bg-col-6 col-w _protection-plan-checkbox"
                          name="isProtectionPlanChecked{{$index}}"
                          [notCheckedValue]="undefined"
                          [(ngModel)]="protectionPlanAgreements[item.product.data.id]"
                          required>
                    <p class="s2 block fw-bold">
                        {{'I have read and I accept the ' | translate }}&nbsp;<a class="underline"
                           (click)="openPdf('assets/pdf/ipid.pdf')">{{'Protection Plan terms and conditions' |
                            translate}}</a>
                    </p>
                </checkbox>
            </input-wrap>
            }
        </div>
        }
        <furniture-assembly class="block"></furniture-assembly>
        <basket-view-totals class="block m-t-5 m-t-9-s m-t-9-m"></basket-view-totals>
        @if ((basket.totals?.subtotal || 0) >= 500) {
        <v12-retail-finance-from-basket class="m-t-6 block"
                                        [amount]="basket.totals.subtotal"></v12-retail-finance-from-basket>
        }
        <ng-container *abIf="'(basketPromoCode) !B'">
            <basket-view-coupon-form class="block m-t-6"></basket-view-coupon-form>
        </ng-container>
        <protection-plans></protection-plans>
        <ng-container *abIf="'(basketPromoCode) B'">
            <basket-view-coupon-form class="block m-t-6"></basket-view-coupon-form>
        </ng-container>
        <ng-container *abIf="'(expressButtons) B'">
            <ng-container *ifApplePayAvailable>
                <barclaycard-apple-pay-express class="block m-t"></barclaycard-apple-pay-express>
            </ng-container>
            <paypal-express-button *ngIf="basket.isSalable"
                                   class="w-12 m-t pos-relative z-0"></paypal-express-button>
            <div class="w-12 center">{{ 'Or' | translate }}</div>
        </ng-container>
        <basket-view-submit [form]="form"
                            class="block m-t"></basket-view-submit>
        <basket-view-pay-with class="block m-t center"
                              [paymentMethods]="content.payment_method_icons"></basket-view-pay-with>
    </div>
    <div class="bg-col-51 p-t-9"
         cy-basketView
         *ifSize="'XL'">
        <div class="c-1"></div>
        <div class="c-6 bg-col-w p-a-9">
            <div class="flex flex-middle flex-justify-between">
                <div>
                    <h1 class="h3 inline-block va-m"
                        translate>Basket</h1>
                    <div class="p1 col-11 m-l-4 inline-block va-m">
                        {{ (basket.qty === 1 ? '% item' : '% items') | translate : basket.qty }}
                    </div>
                </div>
                <span class="p2 col-11 block"
                      *iCms="'basketStockMessaging' of content; skipEmpty: true"
                      text></span>
            </div>
            @if (content.showEuRegulationsMessage) {
            <div [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}"
                 class="p-t-3 p-b-3 m-b-4 m-t-4 center">
                <span class="p1"
                      *iCms="'euRegulationsMessage' of content; content: 'html'"></span>
            </div>
            }
            @if (basket.items.length > 1) {
            <div [ngStyle]="{'background-color': content.bgColorTextBlocks || ''}"
                 class="p-t-3 p-b-3 p-l-12 p-r-12 m-b-4 m-t-4 center">
                <span class="inline-block p1 p-l-2 p-r-2"
                      *iCms="'basketMessage' of content"
                      text></span>
            </div>
            }
            <basket-free-shipping clas="m-t block"></basket-free-shipping>
            @for (item of basket.items; track itemTrackFn($index, item); let last = $last) {
            <div [class.b-b]="!last">
                <basket-view-item class="block m-t"
                                  [ngClass]="{'p-b': !item.product.data.isProductProtectionPlan}"
                                  [item]="item"
                                  cy-basketProd></basket-view-item>
                @if (item?.product?.data?.isProductProtectionPlan) {
                <div class="flex m-b-5">
                    <div class="m-r m-t--4">
                        <div [style.width.rem]="7.8"></div>
                    </div>
                    <input-wrap class="flex-grow"
                                [required]="true"
                                [messages]="{required: 'You must read and accept the terms and conditions to continue'}">
                        <checkbox #protectionPlanCheckbox
                                  class="w-10 p-a-3 m-t--4 bg-col-6 col-w _protection-plan-checkbox"
                                  name="isProtectionPlanChecked{{$index}}"
                                  [notCheckedValue]="undefined"
                                  [(ngModel)]="protectionPlanAgreements[item.product.data.id]"
                                  required>
                            <p class="p2 block fw-bold">
                                {{'I have read and I accept the ' | translate }} <a class="underline"
                                   (click)="openPdf('assets/pdf/ipid.pdf')">{{'Protection Plan terms and
                                    conditions' | translate}}</a>
                            </p>
                        </checkbox>
                    </input-wrap>
                </div>
                }
            </div>
            }
            <furniture-assembly class="block"></furniture-assembly>
        </div>
        <div class="c-4"
             [stickyPanel]="app.client?.sizeId > 1"
             [stickyPanelOffsetTop]="100">
            <div class=" p-t-9 p-b-9 p-l-6 p-r-6 bg-col-w">
                <h2 class="h3"
                    translate>Order summary</h2>
                <basket-view-totals class="block m-t-6"></basket-view-totals>
                <ng-container *abIf="'(basketPromoCode) !B'">
                    <basket-view-coupon-form class="block m-t m-b-3"></basket-view-coupon-form>
                </ng-container>
                @if (basket.totals?.subtotal >= 500) {
                <v12-retail-finance-from-basket class="m-t-4 block"
                                                [amount]="basket.totals.subtotal"
                                                *abIf="'(v12RetailFinance) A'">
                </v12-retail-finance-from-basket>
                }
                <protection-plans></protection-plans>
                    <paypal-express-button *ngIf="basket.isSalable"
                                           class="w-12 m-t pos-relative z-0"></paypal-express-button>
                    <paypal-pay-in-three-message class="block m-t-2"
                                                 [mode]="'basket'"
                                                 [amount]="basket.totals?.grand_total.toFixed(2)"></paypal-pay-in-three-message>
                    <div class="w-12 center">{{ 'Or' | translate }}</div>
                <basket-view-submit class="block m-t"
                                    [form]="form"></basket-view-submit>
                <basket-view-pay-with class="block m-t center"
                                      [paymentMethods]="content.payment_method_icons"></basket-view-pay-with>
                <ng-container *abIf="'(basketPromoCode) B'">
                    <basket-view-coupon-form class="block m-t-6"></basket-view-coupon-form>
                </ng-container>
            </div>
            @if (content.sideImage || content.sideCopy) {
            <div class="center m-t-6">
                <div class="w-6">
                    <div [ngClass]="content.sideImageRatio || ratio-1-1">
                        <img [image]="content.sideImage"
                             class="rf">
                    </div>
                    <p *iCms="'sideCopy' of content; skipEmpty: true"
                       class="m-t"
                       text></p>
                </div>
            </div>
            }
        </div>
    </div>
    <div class="wrap-s wrap-m bg-col-51 bg-col-w-s bg-col-w-m flex flex-justify-center">
        <div class="w-10-x w-10-l w-12 ">
            <icms-outlet [components]=" content.bottomComponents">
            </icms-outlet>
        </div>
    </div>
    }
    @if (!basket.qty) {
    <div style="min-height: 600px;"
         class="bg-col-51-x bg-col-51-l">
        <div class="wrap p-b-3-s p-b-3-m p-t-4"
             *ifSize="'SM'">
            <div class="m-t-9">
                <h1 class="h3 inline-block va-m"
                    translate>Basket</h1>
            </div>
            <div class="center m-t">
                <span>{{'Your basket is empty' | translate}}</span>
            </div>
            <div class="center m-t">
                <a [routerLink]="'/' | lastCategoryPath"
                   class="button">{{'Continue shopping' | translate}}</a>
            </div>
        </div>
        <div class="p-t-9"
             cy-basketView
             *ifSize="'XL'">
            <div class="c-1"></div>
            <div class="c-10 p-a-9">
                <div>
                    <h1 class="h3 inline-block va-m"
                        translate>Basket</h1>
                </div>
                <div class="m-t-6 ta-center">
                    <p class="p2">{{'Your basket is empty' | translate}}</p>
                    <div class="m-t">
                        <a [routerLink]="'/' | lastCategoryPath"
                           class="button">{{'Continue shopping' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
        <icms-outlet [components]=" content.emptyComponents">
        </icms-outlet>
    </div>
    }

</form>